import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';

import posthog from 'posthog-js';

// import { ENVIRONMENT } from '../providers/environment.provider';

@Injectable({
  providedIn: 'root',
})
export class PostHogService {
  // private readonly _env = inject(ENVIRONMENT);
  private readonly _ngZone = inject(NgZone);
  private readonly _platformId = inject(PLATFORM_ID);

  constructor() {
    this._initPostHog();
  }

  private _initPostHog() {
    if (!isPlatformBrowser(this._platformId)) {
      return;
    }
    this._ngZone.runOutsideAngular(() => {
      if (posthog) {
        posthog.init('phc_CzyxWSKugT7QckqLhRoa8IvuWiB84Gc4o0IrhnZnYDj', {
          api_host: 'https://d.markwealth.me', // your managed reverse proxy domain
          ui_host: 'https://us.posthog.com', // necessary because you're using a proxy, this way links will point back to PostHog properly
          defaults: '2026-01-30',
          person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
        });
      }
    });
  }
}
